import { ROUTE_TASKS } from "@/constants/routes.constants";
import { AppContext } from "@/services/AppContext/appContext";
import {
  CommandGroup,
  CommandItem,
  CommandList,
  CommandSeparator,
} from "@/shadcn/components/ui/command";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shadcn/components/ui/tooltip";
import { locForGetRecentSearches } from "@/utils/localForageUtils";
import { getReadableName } from "@/utils/utils";
import { CheckCircle } from "lucide-react";
import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

type SearchBoxFilterBasicProps = {
  inputRef: React.MutableRefObject<HTMLInputElement | null>;
  buttonRecentSearchesSectionRef: React.MutableRefObject<HTMLDivElement | null>;
  listedTasksRef: React.MutableRefObject<HTMLDivElement | null>;
};

const SearchBoxFilterBasic: React.FC<SearchBoxFilterBasicProps> = ({
  inputRef,
  buttonRecentSearchesSectionRef,
  listedTasksRef,
}) => {
  const { precacheTasks } = useContext(AppContext);
  const nav = useNavigate();
  const location = useLocation();
  const [recentSearches, setRecentSearches] = React.useState<string[]>([]);

  // Check LS for recent search
  useEffect(() => {
    locForGetRecentSearches().then((res) => {
      console.log("Recent searches", res);
      if (!res) return;
      setRecentSearches(res);
    });
  }, [location.search]);

  return (
    <>
      <CommandList ref={listedTasksRef} className="flex flex-col">
        <CommandGroup
          ref={listedTasksRef}
          className="max-h-[300px] overflow-y-auto"
        >
          {precacheTasks &&
            precacheTasks.map((task) => (
              <CommandItem
                key={task.id}
                value={task.title + task.id + task.assignee_name}
                onSelect={() => {
                  // If inputRef.current is focused, return, for pressing enter to search
                  if (
                    inputRef.current &&
                    document.activeElement === inputRef.current
                  ) {
                    return;
                  }
                  nav(`${ROUTE_TASKS}/${task.id}`);
                }}
              >
                <div className="grid grid-cols-[auto_1fr_auto] w-full items-center">
                  <div className="mr-2">
                    <CheckCircle
                      className={`w-4 h-4 ${
                        task.status === "complete"
                          ? "text-green-500"
                          : "text-gray-700"
                      } md:filter-none cursor-pointer`}
                      onClick={async (e) => {
                        console.log("clicked");
                        e.stopPropagation();
                        // const newStatus =
                        // task.status === "complete"
                        //     ? "incomplete"
                        //     : "complete";
                        // await handleStatusUpdate(childTask.id, newStatus);
                      }}
                    />
                  </div>
                  <div className="truncate">{task.title}</div>
                  <div className="text-end ml-2">{task.assignee_name}</div>
                </div>
              </CommandItem>
            ))}
        </CommandGroup>
      </CommandList>

      <CommandSeparator />
      <div ref={buttonRecentSearchesSectionRef} className="py-2 px-1">
        <div className="px-2">
          <div className="pb-1">
            <div className="font-semibold text-xs opacity-90 pb-1">
              Recent Searches
            </div>
            {/* Loop through recent searches */}
            <div className="flex flex-row justify-start gap-2">
              {recentSearches.map((search) => (
                <TooltipProvider key={search}>
                  <Tooltip>
                    <TooltipTrigger>
                      <div
                        className="max-w-20 cursor-pointer font-extralight text-xs hover:underline truncate"
                        key={search}
                        onClick={() => {
                          nav(search);
                        }}
                      >
                        {getReadableName(search)}
                      </div>
                    </TooltipTrigger>
                    <TooltipContent>
                      <div className="p-2 bg-primary rounded-md text-primary-foreground text-xs">
                        {getReadableName(search)}
                      </div>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              ))}
            </div>
          </div>
          {/* Favorites */}
          {/* <div>
                        <div className="font-semibold text-xs opacity-90 pb-1">
                          Favorite Searches
                        </div>
                        <div className="flex flex-row gap-2">
                          {favoriteSearches.map((search) => (
                            <div
                              className="cursor-pointer font-extralight text-xs hover:underline"
                              key={search.id}
                              onClick={() => {
                                nav(`/search${search.search}`);
                              }}
                            >
                              {search.name}
                            </div>
                          ))}
                        </div>
                      </div> */}
        </div>
      </div>
    </>
  );
};

export default SearchBoxFilterBasic;
